import React, { RefObject } from 'react'
import { SubmitHandler, UseFormReturn } from 'react-hook-form'
import { IClient } from 'src/app/shared/models/clientSetup.model'
import { CustomConfirmationModalRef } from '../components/CustomConfirmationModal'
import { InvalidEditAccountModalRef } from '../components/InvalidEditAccountModal'
import { EditAccountFormValues } from '../models'
import { PayeeMatchWarningRef } from '../components/PayeeMatchWarningModal'

export enum AccountStatus {
  New = 'new',
  Active = 'active',
  ARCHIVE = 'archive',
  UNARCHIVE = 'unarchive',
}

export interface EditAccountContextProps {
  loading: boolean
  isFetched: boolean
  form: UseFormReturn<EditAccountFormValues>
  checkExceptionProcessingType: string
  achExceptionProcessingType: string
  modalRef: RefObject<CustomConfirmationModalRef>
  payeeMatchWarningRef: RefObject<PayeeMatchWarningRef>
  invalidEditAccountRef?: RefObject<InvalidEditAccountModalRef>
  setSwitchChanged: React.Dispatch<React.SetStateAction<boolean>>
  onSubmit: SubmitHandler<EditAccountFormValues>
  client: IClient | null
}

export const EditAccountContext = React.createContext<EditAccountContextProps>({
  loading: false,
  isFetched: false,
  form: null as any,
  checkExceptionProcessingType: '',
  achExceptionProcessingType: '',
  modalRef: null as any,
  payeeMatchWarningRef: null as any,
  invalidEditAccountRef: null as any,
  setSwitchChanged: () => {},
  onSubmit: () => {},
  client: null,
})

export const useEditAccountContext = () => React.useContext<EditAccountContextProps>(EditAccountContext)
